// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Config$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/configs/Config.mjs";
import * as Environments$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/constants/Environments.mjs";
import * as PartnersRepo$PorterinFeature from "./PartnersRepo.mjs";
import * as DummyPartnersRepo$PorterinFeature from "./DummyPartnersRepo.mjs";

function getRepo(param) {
  if (Config$PorterinUtils.env === Environments$PorterinUtils.development) {
    return {
            getMainPageContent: DummyPartnersRepo$PorterinFeature.getMainPageContent,
            fetchPartnerVehicles: DummyPartnersRepo$PorterinFeature.fetchPartnerVehicles,
            submitAttachVehicleForm: DummyPartnersRepo$PorterinFeature.submitAttachVehicleForm
          };
  } else {
    return PartnersRepo$PorterinFeature;
  }
}

export {
  getRepo ,
}
/* Config-PorterinUtils Not a pure module */
